export const MANAGEMENT_REVIEWS = [
  {
    name: 'shvets',
    text: 'shvetsText',
    subtitle: 'shvetsSubtitle',
  },
  {
    name: 'pogosyan',
    text: 'pogosyanText',
    subtitle: 'pogosyanSubtitle',
  },
];
